/*
 * Muestra el aviso de autoservicio que corresponde al motivo elegido en el
 * formulario de contacto (sections/main-contact.liquid).
 *
 * Es una mejora progresiva: los avisos ya vienen en el HTML con el atributo
 * 'hidden' y aquí solo se alterna cuál se ve. Sin JS no aparece ninguno y el
 * formulario se comporta exactamente igual.
 *
 * Se escucha el <select> nativo porque custom-select.js le asigna el valor y
 * dispara 'change' cada vez que se elige una opción, tanto con ratón como con
 * teclado.
 */
(function () {
  'use strict';

  function init(container) {
    var select = document.getElementById(container.dataset.reasonHints);
    if (!select) return;

    var items = container.querySelectorAll('[data-reason]');
    if (!items.length) return;

    function update() {
      for (var i = 0; i < items.length; i++) {
        items[i].hidden = items[i].dataset.reason !== select.value;
      }
    }

    select.addEventListener('change', update);

    // El navegador puede restaurar la selección al volver atrás.
    update();
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-reason-hints]');
    for (var i = 0; i < containers.length; i++) init(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El personalizador recarga la sección sin recargar la página.
  document.addEventListener('shopify:section:load', initAll);
})();
